<nav
  class="navbar navbar-expand-lg navbar-dark max-zindex fixed-top box-shadow p-2 bg-pattern"
  id="mainNav"
  *ngIf="isLoggedIn"
  [style.background-image]="'url(' + bannerSrc + ')'"
>
  <button
    id="sidebarCollapse"
    class="navbar-toggler p-1 mr-2"
    *ngIf="isLoggedIn"
    (click)="showHideSidebar()"
  >
    <span class="navbar-toggler-icon"></span>
  </button>
  <a class="navbar-brand p-0" href="#">
    <!-- <img src="../../../../assets/images/finreg_logo.png" height="35" class="d-inline-block align-top" alt=""> -->
    <img [src]="imageSrc" height="35" class="d-inline-block align-top" alt="" />
  </a>

  <ul
    class="navbar-nav ml-auto btn-group custom-header-left-nav hide-on-medium"
    dropdown
    #dropdown="bs-dropdown"
    [autoClose]="true"
    *ngIf="isLoggedIn"
  >
    <li class="custom_navlist" *ngIf="helpData && helpData.helpText">
      <a href="/help" target="_blank" class="help-link" title="Help">
        <span class="fa fa-question-circle"></span
      ></a>
    </li>
    <li class="custom_navlist" *ngIf="loggedInUser && loggedInUser.isSAML">
      <a class="nav-link text-white cursor-pointer a-link">
        Welcome, {{ loggedInUser.fullName }}
      </a>
    </li>
    <li class="custom_navlist" *ngIf="loggedInUser && !loggedInUser.isSAML">
      <a dropdownToggle class="nav-link text-white cursor-pointer a-link">
        Welcome, {{ loggedInUser.fullName }}
        <ul
          id="dropdown-triggers-manual"
          *dropdownMenu
          class="dropdown-menu dropdown-menu-right p-0 navbar-user"
          role="menu"
          aria-labelledby="button-triggers-manual"
        >
          <li class="nav-item">
            <a class="nav-link a-link" id="logout-btn" (click)="forceSignOff()">
              <i class="fa fa-sign-out"></i>
              <span class="nav-link-text">Sign Out</span>
            </a>
          </li>
        </ul>
      </a>
    </li>
    <li class="custom_navlist">
      <a target="_blank" class="help-link" title="Division">
        <label
          class="left inline control-label mb-0"
          *ngIf="userJurisdiction && userJurisdiction.length == 1"
          >{{ divisionName }}</label
        >
        <select
          *ngIf="userJurisdiction && userJurisdiction.length > 1"
          class="form-control form-control-sm"
          style="font-size: 1rem"
          (change)="changeDivision($event.target)"
          [(ngModel)]="divisionId"
        >
          <option [value]="jrds.id" *ngFor="let jrds of userJurisdiction">
            {{ jrds.name }}
          </option>
        </select>
      </a>
    </li>

    <!-- <a class="nav-link text-white cursor-pointer" *ngIf="loggedInUser">
      Welcome {{loggedInUser.fullName}}
    </a> -->
  </ul>
</nav>

<nav
  style="z-index: 1020 !important"
  class="fixed-top"
  #navbar
  id="sidebar"
  [ngClass]="isCollapsed ? 'active' : ''"
  *ngIf="isLoggedIn && commonService.isNavbarShow"
>
  <ul
    class="navbar-nav navbar-common bg-white"
    id="exampleAccordion"
    *ngIf="loggedInUser"
  >
    <app-progress-bar [isLoading]="isLoadingMenu"></app-progress-bar>
    <ng-container *ngFor="let parent of libraryMenu">
      <li
        class="nav-item no-child-parent"
        *ngIf="
          !parent.parentId &&
          parent.screenUrl &&
          parent.screenName !== 'Global Library' &&
          parent.screenName !== 'Reporting Templates'
        "
        (click)="toggleClass()"
        id="{{ parent.orderNo }}-item"
        [routerLink]="[parent.screenUrl]"
        [routerLinkActive]="['active']"
      >
        <a
          class="nav-link a-link"
          id="{{ parent.orderNo }}-link"
          aria-expanded="false"
        >
          <span class="nav-link-text fw">{{ parent.screenName }}</span>
        </a>
      </li>
      <li
        class="nav-item collapsed"
        *ngIf="
          !parent.parentId &&
          !parent.screenUrl &&
          parent.screenName !== 'Global Library'
        "
      >
        <a
          class="nav-link nav-link-collapse collapsed dropdown-toggle a-link"
          data-toggle="collapse"
          (click)="parent.isCollapsed = !parent.isCollapsed"
          [attr.aria-expanded]="parent.isCollapsed"
        >
          <span class="nav-link-text fw">{{ parent.screenName }}</span>
        </a>
        <ul
          class="collapse list-unstyled"
          [ngClass]="
            parent.screenName === 'Global Library' ? 'library-menu' : ''
          "
          [collapse]="
            parent.screenName === 'Global Library'
              ? !parent.isCollapsed
              : parent.isCollapsed
          "
          (click)="collapseMenu(parent.isCollapsed)"
        >
          <ng-container *ngFor="let child of libraryMenu">
            <li
              class="nav-item"
              *ngIf="parent.id === child.parentId"
              (click)="toggleClass()"
              routerLink="{{ child.screenUrl }}"
              id="{{ child.orderNo }}-item"
              [class.no-event]="loggedInUser.planType === 5"
              [routerLinkActive]="['active']"
            >
              <a
                *ngIf="child.screenUrl.indexOf('library/') < 0"
                [routerLink]="child.screenUrl"
                class="nav-link a-link"
                data-parent="#child.ParentId"
                id="{{ child.orderNo }}-link"
                aria-expanded="false"
              >
                <span class="nav-link-text">{{ child.screenName }}</span>
              </a>
            </li>
          </ng-container>
        </ul>
      </li>
      <li
        class="nav-item no-child-parent"
        *ngIf="
          !parent.parentId &&
          parent.screenUrl &&
          parent.screenName === 'Global Library'
        "
      >
        <div class="menu-item-div">
          <div
            class="hover-div"
            [ngClass]="currentUrl === parent.screenUrl ? 'active' : null"
          >
            <a href="{{ parent.screenUrl }}" class="a-lib-link">
              <div class="menu-item-left fw item-div">
                {{ parent.screenName }}
              </div>
            </a>
            <div
              class="menu-item-right item-div"
              (click)="parent.isCollapsed = !parent.isCollapsed"
            >
              <span class="fa fa-caret-down"></span>
            </div>
          </div>
        </div>
        <ul class="list-unstyled library-menu" *ngIf="parent.isCollapsed">
          <ng-container *ngFor="let parentChild of libraryMenu">
            <div
              class="menu-item-div"
              *ngIf="
                parent.id === parentChild.parentId &&
                !parentChild.isChildSection
              "
            >
              <div
                class="hover-div"
                [ngClass]="
                  currentUrl === parentChild.screenUrl ? 'active' : null
                "
              >
                <a
                  class="a-lib-link"
                  (click)="redirectLink(parentChild.screenUrl)"
                >
                  <div class="menu-item-left item-div pl-4">
                    {{ parentChild.screenName }}
                  </div>
                </a>
                <div
                  class="menu-item-right item-div"
                  (click)="parentChild.isCollapsed = !parentChild.isCollapsed"
                  *ngIf="
                    parentChild.screenUrl !== '/library/rulebook-dashboard'
                  "
                >
                  <span class="fa fa-caret-down"></span>
                </div>
              </div>
              <ng-container *ngFor="let child of libraryMenu">
                <div
                  class="hover-div"
                  [ngClass]="
                    currentUrl === decodeUrl(child.screenUrl) ? 'active' : null
                  "
                >
                  <a class="a-lib-link" (click)="redirectLink(child.screenUrl)">
                    <div
                      class="item-div pl-4 ml-4"
                      *ngIf="
                        parentChild.id === child.parentId &&
                        !parentChild.isCollapsed &&
                        !child.isChildSection &&
                        child.screenUrl.indexOf('library/') > -1
                      "
                    >
                      {{ child.screenName }}
                    </div>
                  </a>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </ul>
      </li>
      <!--For new Template in Regulation -- Soustav-->
      <li
        class="nav-item no-child-parent"
        *ngIf="
          !parent.parentId &&
          parent.screenUrl &&
          parent.screenName === 'Reporting Templates'
        "
      >
        <div class="menu-item-div">
          <div
            class="hover-div"
            [ngClass]="currentUrl === parent.screenUrl ? 'active' : null"
          >
            <!-- <a href="{{parent.screenUrl}}" class="a-lib-link"> -->
            <div class="menu-item-left fw item-div">
              {{ parent.screenName }}
            </div>
            <!-- </a> -->
            <div
              class="menu-item-right item-div"
              (click)="parent.isCollapsed = !parent.isCollapsed"
            >
              <span class="fa fa-caret-down"></span>
            </div>
          </div>
        </div>
        <ul class="list-unstyled library-menu" *ngIf="!parent.isCollapsed">
          <ng-container *ngFor="let parentChild of libraryMenu">
            <div
              class="menu-item-div"
              *ngIf="
                parent.id === parentChild.parentId &&
                !parentChild.isChildSection
              "
            >
              <div class="hover-div">
                <!-- <a class="a-lib-link"> -->
                <div class="menu-item-left item-div pl-4">
                  {{ parentChild.screenName }}
                </div>
                <!-- </a> -->
                <div
                  class="menu-item-right item-div"
                  (click)="parentChild.isCollapsed = !parentChild.isCollapsed"
                >
                  <span class="fa fa-caret-down"></span>
                </div>
              </div>
              <ng-container *ngFor="let child of libraryMenu">
                <div
                  class="hover-div"
                  [ngClass]="currentUrl === child.screenUrl ? 'active' : null"
                >
                  <a class="a-lib-link" (click)="redirectLink(child.screenUrl)">
                    <div
                      class="item-div pl-4 ml-4"
                      *ngIf="
                        parentChild.id === child.parentId &&
                        !parentChild.isCollapsed &&
                        !child.isChildSection &&
                        child.screenUrl.indexOf('library/') > -1
                      "
                    >
                      {{ child.screenName }}
                    </div>
                  </a>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </ul>
      </li>
    </ng-container>
  </ul>
</nav>

<div
  class="sidebar-overlay"
  [ngClass]="!isCollapsed && windowWidth < 992 ? 'active' : ''"
  (click)="isCollapsed = !isCollapsed"
></div>
